import { createApp } from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import { loadFonts } from './plugins/webfontloader';
import router from './router/router.js';
import axiosPlugin from './plugins/axios';

// Import the global CSS file
import './assets/global.css';

loadFonts();

createApp(App).use(vuetify).use(router).use(axiosPlugin).mount('#app');
